import api from './api'

export default {
  powerAndInsolation(id, data) {
    return api.post(`/stations/powers-and-insolation/${id}`, data)
  },
  lineValues(id, data) {
    return api.post(`/stations/line-values/${id}`, data)
  },
  productionAndInsolation(id) {
    return api.get(`/stations/production/${id}`)
  },
  productionAndInsolationByHour(id, data) {
    return api.post(`/stations/production-by-hour/${id}`, data)
  },
  productionRatio(id) {
    return api.get(`/stations/production-ratio/${id}`)
  },
  dateTimeData(id, dateTime) {
    return api.post(`/stations/datetime-data/${id}`, { dateTime })
  },
  // /api/stations/inverters-production/{id}
  invertersProduction(id, from, to) {
    return api.post(`/stations/inverters-production/${id}`, {
      from,
      to
    })
  },
  gridInvertersProduction(id, from, to) {
    return api.post(`/stations/grid-inverters-production/${id}`, {
      from,
      to
    })
  }
}
